import * as TYPES from './mutations-types'

export default {
  [TYPES.SET_ARTICLES_LIST] (state, loadedList) {
    state.articlesList = loadedList
  },
  [TYPES.SET_ARTICLE_THEMES_LIST] (state, loadedList) {
    state.articleThemesList = loadedList
  }
}
